import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import Insurance from "@/shared/model/Insurance";
import {InsuranceType} from "@/shared/model/insuranceType";
import {computed} from "vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {useNavigationStore} from "@/modules/Navigation/store";
import {IdType} from "@/shared/model/idType";

/*export default {
  name: "InsuranceHeadComponent"
}*/
interface Props {
  insurance?: Insurance;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceComponent',
  props: {
    insurance: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const _navigationStore = useNavigationStore();

const _isKzkOrTz = computed(() => {
  return (
    props.insurance?.insuranceType === InsuranceType.Kzk ||
    props.insurance?.insuranceType === InsuranceType.Tz
  );
});

const _evbVisible = computed(() => {
  return props.insurance?.evb && props.insurance?.evb?.length > 0;
});

function onEvbClick() {
  if (props.insurance?.evb) {
    _navigationStore.showObject(IdType.Evb, props.insurance.evb);
  }
}

function onBlankClick() {
  if (props.insurance?.insuranceExportBlankId) {
    _navigationStore.showObject(IdType.InsuranceExportBlank, props.insurance.insuranceExportBlankId);
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _cache[0] || (_cache[0] = _createElementVNode("td", null, "Produkt", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.productDescription
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("tr", null, [
      _cache[1] || (_cache[1] = _createElementVNode("td", null, "Prämie", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.grossPrice,
          "value-type": "Money"
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("tr", null, [
      _cache[2] || (_cache[2] = _createElementVNode("td", null, "Bestelldatum", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.createDate,
          "value-type": _unref(SogDataLabelValueType).DateTime
        }, null, 8, ["value", "value-type"])
      ])
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[3] || (_cache[3] = _createElementVNode("td", null, "Evb", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.evb
        }, null, 8, ["value"]),
        _withDirectives(_createVNode(SogButton, {
          "mdi-icon": "mdi-information",
          "button-style": _unref(SogButtonStyle).Link,
          onClick: onEvbClick
        }, null, 8, ["button-style"]), [
          [_vShow, _evbVisible.value]
        ])
      ])
    ], 512), [
      [_vShow, _isKzkOrTz.value]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[4] || (_cache[4] = _createElementVNode("td", null, "Formularnummer", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.formNumber
        }, null, 8, ["value"]),
        _withDirectives(_createVNode(SogButton, {
          "mdi-icon": "mdi-file-document",
          "button-style": _unref(SogButtonStyle).Link,
          onClick: onBlankClick
        }, null, 8, ["button-style"]), [
          [_vShow, props.insurance.insuranceExportBlankId]
        ])
      ])
    ], 512), [
      [_vShow, !_isKzkOrTz.value]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Aktivierungscode", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.activationCode
        }, null, 8, ["value"])
      ])
    ], 512), [
      [_vShow, _isKzkOrTz.value]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Aktivierungsdatum", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.activationDate,
          "value-type": _unref(SogDataLabelValueType).DateTime
        }, null, 8, ["value", "value-type"])
      ])
    ], 512), [
      [_vShow, _isKzkOrTz.value]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Gültig bis", -1)),
      _createElementVNode("td", null, [
        _createVNode(SogDataLabel, {
          value: props.insurance.evbValidityDate,
          "value-type": _unref(SogDataLabelValueType).DateTime
        }, null, 8, ["value", "value-type"])
      ])
    ], 512), [
      [_vShow, _isKzkOrTz.value]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Versicherungsbeginn", -1)),
      _createVNode(SogDataLabel, {
        value: props.insurance.inceptionDate,
        "value-type": _unref(SogDataLabelValueType).DateTime
      }, null, 8, ["value", "value-type"])
    ], 512), [
      [_vShow, props.insurance.inceptionDate]
    ]),
    _withDirectives(_createElementVNode("tr", null, [
      _cache[9] || (_cache[9] = _createElementVNode("td", null, "Versicherungsende", -1)),
      _createVNode(SogDataLabel, {
        value: props.insurance.expiryDate,
        "value-type": _unref(SogDataLabelValueType).DateTime
      }, null, 8, ["value", "value-type"])
    ], 512), [
      [_vShow, props.insurance.expiryDate]
    ])
  ]))
}
}

})